// Updated TypeScript for NCD Questionnaire Component
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from '../../../shared/services/registration.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MasterService } from 'src/app/shared/services/master.service';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
declare let $: any;

@Component({
  selector: 'app-ncd-questionary',
  templateUrl: './ncd-questionary.component.html',
  styleUrls: ['./ncd-questionary.component.css'],
})
export class NcdQuestionaryComponent implements OnInit {
  @Input() benID: any;
  @Input() memberID: any;
  @Input() patientDetails: any;
  @Input() ScreenName: any;
allModules = [
    {
      label: 'Mother and Child Services',
      icon: 'assets/titleimages/mother child.png',
    },
    {
      label: 'NCD Screening',
      icon: 'assets/titleimages/ncd screen.png',
    },
    {
      label: '(0-6) yrs Child Services',
      icon: 'assets/titleimages/o to 6.png',
    },
    {
      label: 'Diagnosis',
      icon: 'assets/titleimages/diagnosis.png',
    },
    // Add other modules here but filter below
  ];
  
  filteredModules = [];
  surveyCards: string[] = [];
  selectedSurvey: any = null;
  selectedAnswers: { [questionId: number]: any } = {};
  surveyData: any;
  activeTabIndex = 0;
  cardClick = false;
  beforeCardclick = true;
  ncdSaveEnable = false;
  completedSurveys: { [key: string]: boolean } = {};
  surveyTransDetails: any[] = [];
  currentSurvey: string;
  surveyName : string='NCD Screening';
  errors: { [key: number]: boolean } = {};
  enteredHeight: number | null = null;
  enteredWeight: number | null = null;
  parentQuestionIndexMap = new Map<number, string>();
  indexNumber: number;
  selectedQuestionIndexNumber: number=0;


  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private master: MasterService,
    private datepipe: DatePipe,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadData();
  if (this.ScreenName == 'patientList') {
      this.ncdSaveEnable = true;
    } else {
      this.ncdSaveEnable = false;
    }
    console.log('patientDetails', this.patientDetails);
        this.setFilteredModules();
  }

  loadData() {
    this.regService.getwithoutlogin('survey/survey/getall').subscribe({
      next: (res: any) => {
        if (res?.status === 'OK') {
          this.surveyData = res.data;
        } else {
          this.toastr.error(res.message);
        }
      },
      error: (err: HttpErrorResponse) => this.toastr.error(err.message)
    });
  }
setFilteredModules() {
    const gender =
      this.patientDetails?.gender_id == '2'
        ? 'female'
        : this.patientDetails?.gender_id == '1'
        ? 'male'
        : 'Transgender';
    const age = this.patientDetails?.age;

    // Always include Diagnosis
    const diagnosis = this.allModules.find((m) => m.label === 'Diagnosis');

    this.filteredModules = [];

    if (age !== undefined && age <= 6) {
      // Age-based rule
      const childService = this.allModules.find(
        (m) => m.label === '(0-6) yrs Child Services'
      );
      if (childService) this.filteredModules.push(childService);
    } else if (gender === 'male') {
      // Male
      const ncd = this.allModules.find((m) => m.label === 'NCD Screening');
      if (ncd) this.filteredModules.push(ncd);
    } else if (gender === 'female') {
      // Female
      const ncd = this.allModules.find((m) => m.label === 'NCD Screening');
      const motherChild = this.allModules.find(
        (m) => m.label === 'Mother and Child Services'
      );
      if (ncd) this.filteredModules.push(ncd);
      if (motherChild) this.filteredModules.push(motherChild);
    }

    if (diagnosis) this.filteredModules.push(diagnosis);
  }
  navigateTo(item: any, label: any) {
    const gender = this.patientDetails?.gender_id == '2' ? 'female' : this.patientDetails?.gender_id == '1' ? 'male' : 'Transgender';
    this.surveyCardsList(gender, label);
    this.beforeCardclick = false;
  }

 surveyCardsList(gender: string, label: any) {
    const allSurveys = this.surveyData.map(
      (item) => item.surveyLang?.[0]?.langStr || 'Unnamed Survey'
    );

    // Filter based on gender
    if (label === 'NCD Screening') {
      if (gender === 'male' || gender === 'Transgender') {
        this.surveyCards = allSurveys.filter((card) =>
          [
            'CBAC HISTORY',
            'DIABETES SCREENING',
            'HYPERTENSION SCREENING',
            'ORAL SCREENING',
          ].includes(card)
        );
      } else if (gender === 'female') {
        this.surveyCards = allSurveys.filter((card) =>
          [
            'CBAC HISTORY',
            'DIABETES SCREENING',
            'HYPERTENSION SCREENING',
            'ORAL SCREENING',
            'BREAST SCREENING',
            'CERVICAL SCREENING',
          ].includes(card)
        );
      } else {
        this.surveyCards = []; // fallback or default
      }
    }
    if (label === 'Mother and Child Services') {
      this.surveyCards = allSurveys.filter((card) =>
        ['Mother And Child Services'].includes(card)
      );
    }
    if (label === '(0-6) yrs Child Services') {
      this.surveyCards = allSurveys.filter((card) =>
        ['0 to 6 Years Screening'].includes(card)
      );
    }
    if (label === 'Diagnosis') {
      this.surveyCards = allSurveys.filter((card) =>
        ['Diagnosis'].includes(card)
      );
    }

    console.log('Filtered surveyCards:', this.surveyCards);
  }

  onCardClick(survey: string) {
    this.surveyName = survey
    const index = this.surveyCards.findIndex(s => s === survey);
    const firstIncomplete = this.surveyCards.slice(0, index).find(s => !this.completedSurveys[s]);
    if (firstIncomplete) {
      this.toastr.error(`Please fill "${firstIncomplete}" before proceeding.`);
      return;
    }
    this.loadSurvey(survey);
    setTimeout(() => {
     if(this.surveyName == "0 to 6 Years Screening") {

     }else{
this.patchPatientDetailsToSurveyByScreen(this.ScreenName , this.patientDetails); // <-- Call it here
     }
          
    }, 500);
  }

 loadSurvey(survey: string) {
  this.currentSurvey = survey;
  this.cardClick = true;
  this.activeTabIndex = 0;

  this.selectedSurvey = this.surveyData.find(
    item => item.surveyLang?.[0]?.langStr === survey
  );

  // ✅ Filter "Menstrual History" section if gender is male
  const gender = this.patientDetails?.gender_id;
  if (gender == '1') { // 1 = Male
    this.selectedSurvey.sections = this.selectedSurvey.sections.filter(
      (section: any) =>
        !section.sectionLang?.[0]?.langStr?.toLowerCase().includes('menstrual')
    );
  }
// this.resetQuestionCounters();
  this.initializeSelectedAnswers();
}

  initializeSelectedAnswers(): void {
    if (this.selectedSurvey?.sections) {
      for (let section of this.selectedSurvey.sections) {
        for (let question of section.questions) {
          if (!(question.id in this.selectedAnswers)) {
            this.selectedAnswers[question.id] = null;
          }
        }
      }
    }
  }

  getSectionLabel(section: any, index: number): string {
    return section?.sectionLang?.[0]?.langStr || `Section ${index + 1}`;
  }

  getSectionTitle(section: any): string {
    return section.sectionLang.find((l: any) => l.languageID === 1)?.langStr || 'Untitled Section';
  }

  getQuestionLabel(question: any): string {
    return question.questionLang.find((q: any) => q.languageID === 1)?.langStr || 'Untitled Question';
  }

  getAnswerLabel(answer: any): string {
    return answer.answerLang.find((a: any) => a.languageID === 1)?.langStr || 'Option';
  }

  shouldDisplayQuestion(question: any): boolean {
    if (!question.targetquestionID || question.targetquestionID === 0) return true;
    const selected = this.selectedAnswers[question.targetquestionID];    
    return selected === question.targetanswerID;
    
  }

  isMandatory(question: any): boolean {
    return question.mandatory && this.shouldDisplayQuestion(question);
  }

updateSurveyDetail(question: any, rawAnswer: any,i:number, type: any): void {
  // if(this.selectedQuestionIndexNumber == 0){
  // this.selectedQuestionIndexNumber = i
  // }
   
  const questionId = question.questionLang?.[0]?.questionID || question.id;
  const survey_id = this.selectedSurvey?.surveyLang[0]?.surveyID;
  let answer = rawAnswer?.target?.value ?? rawAnswer;
  let answerLabel = '';

  if(type == "date"){
    answer = this.datepipe.transform(rawAnswer,'yyyy-MM-dd')
    rawAnswer = this.datepipe.transform(rawAnswer,'yyyy-MM-dd')
  }
  // Convert dropdown/radio/text/checkbox value to label

// Convert dropdown/radio/etc to label
if (['dropdown','radio'].includes(type)) {
  
  const selectedAnswer = question.answers?.find((ans: any) => ans.id == answer);

  if (selectedAnswer) {
    answer = this.getAnswerLabel(selectedAnswer);  // Use label
  } else {
    answer = null;  // No matching answer = clear
  }
}

  // Format date if applicable
  if (
    answer instanceof Date ||
    (!isNaN(Date.parse(answer)) && typeof answer === 'string' && type === 'date')
  ) {
    const date = new Date(answer);
    answer = this.datepipe.transform(date, 'yyyy-MM-dd');
  }

  // Store/update entry in surveyTransDetails
  const existingIndex = this.surveyTransDetails.findIndex(
    item => item.question_id === questionId && item.survey_id === survey_id
  );

  const isEmpty = answer === null || answer === undefined || (typeof answer === 'string' && answer.trim() === '');

  if (isEmpty) {
    if (existingIndex !== -1) {
      this.surveyTransDetails.splice(existingIndex, 1);
    }
  } else {
    const newEntry = { survey_id, question_id: questionId, answer, visit_no: null };
    if (existingIndex !== -1) {
      this.surveyTransDetails[existingIndex] = newEntry;
    } else {
      this.surveyTransDetails.push(newEntry);
    }
  }

  // ==== BMI AUTO-CALCULATION LOGIC ====
  const label = this.getQuestionLabel(question).toLowerCase();

// Store latest height/weight values from answers
if (label.includes('height')) {
  const val = parseFloat(this.selectedAnswers[question.id]);
  this.enteredHeight = isNaN(val) ? null : val;
}

if (label.includes('weight')) {
  const val = parseFloat(this.selectedAnswers[question.id]);
  this.enteredWeight = isNaN(val) ? null : val;
}

// Calculate BMI if both values are present
if (this.enteredHeight && this.enteredWeight) {
  const heightM = this.enteredHeight / 100;
  const bmi = this.enteredWeight / (heightM * heightM);
  const bmiRounded = bmi.toFixed(2);

  const bmiQuestion = this.selectedSurvey.sections
    .flatMap(section => section.questions)
    .find(q => this.getQuestionLabel(q).toLowerCase().includes('bmi'));

  if (bmiQuestion) {
    const bmiId = bmiQuestion.id;
    this.selectedAnswers[bmiId] = bmiRounded;

    const bmiIndex = this.surveyTransDetails.findIndex(
      entry => entry.question_id === bmiId && entry.survey_id === survey_id
    );

    const bmiEntry = {
      survey_id,
      question_id: bmiId,
      answer: bmiRounded,
      visit_no: null,
    };

    if (bmiIndex !== -1) {
      this.surveyTransDetails[bmiIndex] = bmiEntry;
    } else {
      this.surveyTransDetails.push(bmiEntry);
    }
  }
}

// ==== SUB-QUESTION CLEARING ====
if (type === 'radio' || type === 'dropdown') {
  const triggeredAnswerId = rawAnswer?.target?.value ?? rawAnswer;

  question.answers?.forEach((ans: any) => {
    const isUnselected = ans.id !== +triggeredAnswerId;

    if (isUnselected && Array.isArray(ans.questions)) {
      ans.questions.forEach((subQ: any) => {
        // 👇 Clear value and remove from selectedAnswers
        this.selectedAnswers[subQ.id] = null;

        const subIndex = this.surveyTransDetails.findIndex(
          entry => entry.question_id === subQ.id && entry.survey_id === survey_id
        );
        if (subIndex !== -1) {
          this.surveyTransDetails.splice(subIndex, 1);
        }

        // Clear validation error
        this.errors[subQ.id] = false;

        // 🔁 Recursively clear nested sub-sub-questions if present
        subQ.answers?.forEach((childAns: any) => {
          if (Array.isArray(childAns.questions)) {
            childAns.questions.forEach((nestedQ: any) => {
              this.selectedAnswers[nestedQ.id] = null;

              const nestedIndex = this.surveyTransDetails.findIndex(
                entry => entry.question_id === nestedQ.id && entry.survey_id === survey_id
              );
              if (nestedIndex !== -1) {
                this.surveyTransDetails.splice(nestedIndex, 1);
              }

              this.errors[nestedQ.id] = false;
            });
          }
        });
      });
    }
  });
}

this.clearHiddenSubQuestions();

  console.log('this.surveyTransDetails', this.surveyTransDetails);
}





  toggleCheckbox(questionId: number, answerId: number): void {
    if (!Array.isArray(this.selectedAnswers[questionId])) {
      this.selectedAnswers[questionId] = [];
    }
    const index = this.selectedAnswers[questionId].indexOf(answerId);
    if (index > -1) {
      this.selectedAnswers[questionId].splice(index, 1);
    } else {
      this.selectedAnswers[questionId].push(answerId);
    }
    const survey_id = this.selectedSurvey?.surveyLang[0]?.surveyID;
    const answerString = this.selectedAnswers[questionId].join(', ');
    const existingIndex = this.surveyTransDetails.findIndex(item => item.question_id === questionId && item.survey_id === survey_id);
    if (this.selectedAnswers[questionId].length === 0) {
      if (existingIndex !== -1) this.surveyTransDetails.splice(existingIndex, 1);
    } else {
      const newEntry = { survey_id, question_id: questionId, answer: answerString, visit_no: null };
      if (existingIndex !== -1) this.surveyTransDetails[existingIndex] = newEntry;
      else this.surveyTransDetails.push(newEntry);
    }
  }

  



submitSurvey() {
  const activeSection = this.selectedSurvey.sections[this.activeTabIndex];
  const sectionLabel = activeSection?.sectionLang?.[0]?.langStr?.toLowerCase();
  
  // 🩸 Skip validation if section is Menstrual and gender is male
  const isMenstrualForMale = this.patientDetails?.gender_id === '1' &&
    sectionLabel.includes('menstrual');

  if (isMenstrualForMale) {
    this.completedSurveys[this.currentSurvey] = true;
    if (this.activeTabIndex < this.selectedSurvey.sections.length - 1) {
      this.activeTabIndex++;
    } else {
      this.cardClick = false;
      this.activeTabIndex = 0;
    }
    return;
  }

  let valid = true;
  for (const question of activeSection.questions) {
    if (question.mandatory && this.shouldDisplayQuestion(question)) {
      const value = this.selectedAnswers[question.id];
      const isEmpty =
        value === null ||
        value === undefined ||
        value === '' ||
        (Array.isArray(value) && value.length === 0);
      this.errors[question.id] = isEmpty;
      if (isEmpty) valid = false;
    }
  }

  if (!valid) {
    this.toastr.warning('Please fill all mandatory fields.');
    return;
  }

  this.completedSurveys[this.currentSurvey] = true;

  if (this.activeTabIndex < this.selectedSurvey.sections.length - 1) {
    this.activeTabIndex++;
  } else {
    this.cardClick = false;
    this.activeTabIndex = 0;
  }
}



  onSubmit() {
    const payload = [{
      surveyTransMaster: {
        beneficiary_id: this.benID || null,
        dependent_id: this.memberID || null,
        survey_id: this.selectedSurvey?.id,
        created_by: sessionStorage.loginId,
        summary: {},
        language_id: 1
      },
      surveyTransDetails: this.surveyTransDetails
    }];

    this.regService.getwithoutloginpost('survey/survey-trans-master/save', payload).subscribe({
      next: res => {
        if (res.status === 'OK') {
          this.activeModal.close('Close click');
          this.toastr.success(res.message);
        } else {
          this.toastr.error(res.message);
        }
      },
      error: err => this.toastr.error(err.message)
    });
  }

  onSubmit2() {
    const payload = [{
      surveyTransMaster: {
        beneficiary_id: this.benID || null,
        dependent_id: this.memberID || null,
        survey_id: this.selectedSurvey?.id,
        created_by: sessionStorage.loginId,
        summary: {},
        language_id: 1,
        patient_interaction_id: null
      },
      surveyTransDetails: this.surveyTransDetails
    }];
    this.activeModal.close(payload);
  }

  goToPreviousTab(): void {
    if (this.activeTabIndex > 0) {
      this.activeTabIndex--;
    }
  }

  clearError(questionId: number): void {
  // Ensure errors object is initialized
  if (!this.errors) {
    this.errors = {};
  }

  // Only clear if it exists
  if (questionId != null && this.errors.hasOwnProperty(questionId)) {
    this.errors[questionId] = false;
  }
}


  close() {
    if (this.cardClick){
  this.cardClick = false;
  this.surveyName = 'NCD Screening'
    } 
    else{
this.beforeCardclick = true;
    } 
  }

  getCardIcon(index: number): string {
    const icons = ['fas fa-notes-medical', 'fas fa-syringe', 'fas fa-stethoscope', 'fas fa-tooth', 'fas fa-heartbeat'];
    return icons[index % icons.length];
  }

  getCardColor(index: number): string {
    const colors = ['card-gradient-red', 'card-gradient-yellow', 'card-gradient-purple', 'card-gradient-teal'];
    return colors[index % colors.length];
  }


  // tab handle

handleTabClick(index: number) {
  if (index <= this.activeTabIndex) {
    // Allow going back
    this.activeTabIndex = index;
  } else {
    // Validate all tabs between current and target
    for (let i = this.activeTabIndex; i < index; i++) {
      if (!this.validateTab(i)) {
        this.toastr.warning(`Please fill all mandatory fields in Section ${i + 1} before continuing.`);
        return; // Stop if any intermediate tab is invalid
      }
    }
    this.activeTabIndex = index; // All intermediate tabs are valid
  }
    //  this.resetQuestionCounters(); // ✅ Reset counters here
}




validateTab(index: number): boolean {
  const section = this.selectedSurvey?.sections[index];
  let valid = true;

  for (const question of section?.questions || []) {
    if (question.mandatory && this.shouldDisplayQuestion(question)) {
      const value = this.selectedAnswers[question.id];
      const isEmpty = value === null || value === '' || value === undefined || (Array.isArray(value) && value.length === 0);

      if (!this.errors) this.errors = {};
      this.errors[question.id] = isEmpty;

      if (isEmpty) valid = false;
    }
  }

  return valid;
}

bmiTxtClr(bV: string, t: string): string {
  const bmi = parseFloat(bV);
  if (isNaN(bmi)) return '';

  if (bmi <= 18.5)
    return t === 't' ? 'Underweight' : '#0000ff';
  else if (bmi <= 24.99)
    return t === 't' ? 'Normal Weight' : '#008000';
  else if (bmi <= 29.99)
    return t === 't' ? 'Overweight' : '#9acd32';
  else if (bmi <= 34.99)
    return t === 't' ? 'Obesity (Class I)' : '#ffa500';
  else if (bmi <= 39.99)
    return t === 't' ? 'Obesity (Class II)' : '#ff4500';
  else
    return t === 't' ? 'Greater Morbid Obesity' : '#8b0000';
}

patchPatientDetailsToSurveyByScreen(screenName: string, data: any): void {
  if (!this.selectedSurvey) return;

  const survey_id = this.selectedSurvey?.surveyLang?.[0]?.surveyID;
  const questions = this.selectedSurvey.sections.flatMap((s: any) => s.questions);
  const patchedFieldsLog: string[] = [];

  const patchAndSave = (question: any, rawValue: any, fieldLabel: string) => {
    const type = question.answerType?.name?.toLowerCase();
    let value: any = null;
    switch (type) {
      case 'text box':
        value = rawValue;
        this.selectedAnswers[question.id] = rawValue;
        break;

      case 'radio button':
      case 'dropdown':
        const matched = question.answers?.find(
          (ans: any) => this.getAnswerLabel(ans).toLowerCase() === String(rawValue).toLowerCase()
        );
        if (matched) {
          this.selectedAnswers[question.id] = matched.id;
          value = this.getAnswerLabel(matched);
        } else {
          this.selectedAnswers[question.id] = null;
        }
        break;

      case 'checkbox':
  const isChecked = String(rawValue).toLowerCase() === 'yes' || rawValue === true;
  this.selectedAnswers[question.id] = isChecked;
  value = isChecked;  // 👈 Store true/false directly
  break;

      case 'calendar date':
      case 'current date':
      case 'date':
  if (rawValue && !isNaN(Date.parse(rawValue))) {
    value = this.datepipe.transform(rawValue, 'yyyy-MM-dd');
  } else {
    value = null; // or fallback
  }
  this.selectedAnswers[question.id] = value;
  break;

      default:
        this.selectedAnswers[question.id] = rawValue;
        value = rawValue;
    }

    const existingIndex = this.surveyTransDetails.findIndex(
      (entry) => entry.question_id === question.id && entry.survey_id === survey_id
    );

    const isEmpty = value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

    if (isEmpty) {
      if (existingIndex !== -1) this.surveyTransDetails.splice(existingIndex, 1);
    } else {
      const newEntry = { survey_id, question_id: question.id, answer: value, visit_no: null };
      if (existingIndex !== -1) {
        this.surveyTransDetails[existingIndex] = newEntry;
      } else {
        this.surveyTransDetails.push(newEntry);
      }

      // Log patched field mapping
      patchedFieldsLog.push(`Patched "${fieldLabel}" → "${this.getQuestionLabel(question)}"`);
    }
  };

  const fieldMap: any = {
  'age': data.age,
  'date of birth': this.datepipe.transform(new Date(data.birth_date),'dd-MM-yyyy'),
  'gender': { 1: 'Male', 2: 'Female', 3: 'Transgender' }[data.gender_id] || '',
  'name': data.first_name || data.fullname || '',
  'mobile': data.mobile || data.member_mobile || '',
  'address': data.address || data.user_registration?.address || '',

  ...(screenName === 'POC' && data.beneficiary_medical_records?.[0]?.vital_history && {
    'temperature': data.beneficiary_medical_records[0].vital_history.temperature,
    'pulse': data.beneficiary_medical_records[0].vital_history.pulse,
    'height': data.beneficiary_medical_records[0].vital_history.height,
    'weight': data.beneficiary_medical_records[0].vital_history.weight,
    'systolic': data.beneficiary_medical_records[0].vital_history.systolic,
    'diastolic': data.beneficiary_medical_records[0].vital_history.diastolic,
  })
};


  for (const question of questions) {
    const label = this.getQuestionLabel(question)?.toLowerCase();
    if (!label) continue;

    for (const key in fieldMap) {
      if (label.includes(key) && fieldMap[key] !== undefined && fieldMap[key] !== null) {
        patchAndSave(question, fieldMap[key], key);
      }
    }
  }

  // console.log('✅ Final patched selectedAnswers:', this.selectedAnswers);
  // console.log('✅ Updated surveyTransDetails:', this.surveyTransDetails);
  // console.log('📝 Patched Field Summary:\n' + patchedFieldsLog.join('\n'));
}



clearHiddenSubQuestions(): void {
  const survey_id = this.selectedSurvey?.surveyLang[0]?.surveyID;

  const allQuestions = this.selectedSurvey.sections.flatMap((s: any) => s.questions);

  for (const question of allQuestions) {
    const isVisible = this.shouldDisplayQuestion(question);

    // If hidden, clear value and transfer record
    if (!isVisible) {
      this.selectedAnswers[question.id] = null;

      const index = this.surveyTransDetails.findIndex(
        item => item.question_id === question.id && item.survey_id === survey_id
      );
      if (index !== -1) {
        this.surveyTransDetails.splice(index, 1);
      }

      // Optional: clear error
      if (this.errors) {
        this.errors[question.id] = false;
      }
    }
  }
}



isSurveyValid(): boolean {
  if (!this.selectedSurvey?.sections) return false;

  for (const section of this.selectedSurvey.sections) {
    for (const question of section.questions) {
      if (question.mandatory && this.shouldDisplayQuestion(question)) {
        const value = this.selectedAnswers[question.id];
        const isEmpty =
          value === null ||
          value === undefined ||
          value === '' ||
          (Array.isArray(value) && value.length === 0);

        if (isEmpty) {
          return false;
        }
      }
    }
  }

  return true; // All mandatory visible questions are filled
}

resetQuestionCounters(): void {
  this.lastParentIndex = 0;
  this.selectedQuestionIndexNumber = 0;
}


parentQuestionIndex = 1;
questionNumberMap: { [questionId: number]: string } = {};
isSubQuestion : boolean=false;
subQuestionTracker: { [parentIndex: number]: number } = {};
lastParentIndex=0
visibleParentCounter: number = 0;
lastQuestionTabIndex: number = -1;
getCondition(i:number){
  if(i == 2){i=i-1; return i+1}
   else if(i==4){i=i-1; return i}
  else if(i==6){i=i-2 ; return i}
  else if(i==8){i=i-3 ; return i}
  else if(i==10){i=i-4 ; return i}
  else if(i==12){i=i-5 ; return i}
  else if(i==14){i=i-6 ; return i}
  else if(i==16){i=i-7 ; return i}
  else if(i==18){i=i-8 ; return i}
  else if(i==20){i=i-9 ; return i}
  else if(i==22){i=i-10 ; return i}
  else if(i==24){i=i-11 ; return i}
  else {return i+1}
}
getQuestionNumber(i: number, question: any): string {
  const isSub = question.targetquestionID && question.targetquestionID !== 0;

  const currentSection = this.getActiveSectionTitle();
let tabPersonal:boolean =false
  if (currentSection.toLowerCase().includes('personal history')) {
    tabPersonal=true
  }
  if (!isSub) {
    this.lastParentIndex = 0
    this.selectedQuestionIndexNumber =0
    return tabPersonal ? `${this.getCondition(i)}`: `${i  + 1}.`;
  }
  else{
  //  this.lastParentIndex = this.lastParentIndex+1
   const suffix = String.fromCharCode(97 + this.lastParentIndex++); // 'a' = 97
    return `${suffix}.`;
  }

}
getActiveSectionTitle(): string {
  const section = this.selectedSurvey?.sections?.[this.activeTabIndex];
  return section?.sectionLang?.[0]?.langStr?.toLowerCase() || '';
}








}
